// Match declared crawler identities, not browser brands, referrers, or ISPs.
// This is an analytics heuristic; an unrecognized agent is not proof of a human.
const knownBots = [
  ["Googlebot", /\bGooglebot(?:-[\w]+)?\b/i],
  [
    "Google crawler",
    /\b(?:GoogleOther(?:-[\w]+)?|Google-InspectionTool|AdsBot-Google(?:-Mobile)?|Mediapartners-Google|Storebot-Google|FeedFetcher-Google)\b/i,
  ],
  ["Bingbot", /\b(?:bingbot|BingPreview|adidxbot)\b/i],
  ["DuckDuckBot", /\bDuckDuckBot\b/i],
  ["Applebot", /\bApplebot\b/i],
  ["ExaSearchBot", /\bExaSearchBot\b/i],
  ["Shap", /\bShap(?:Bot|-User)\b/i],
  [
    "Meta crawler",
    /\b(?:meta-webindexer|meta-externalagent|meta-externalfetcher|facebookexternalhit|Facebot)\b/i,
  ],
  ["Dataprovider", /\bDataprovider\.com\b/i],
  ["Perplexity", /\bPerplexity(?:Bot|-User)\b/i],
  ["Reflectionbot", /\bReflectionbot\b/i],
  ["OpenAI crawler", /\b(?:GPTBot|OAI-SearchBot|ChatGPT-User)\b/i],
  ["Claude crawler", /\bClaude(?:Bot|-User|-SearchBot)\b/i],
  [
    "Search crawler",
    /\b(?:YandexBot|Baiduspider|PetalBot|Slurp|Sogou web spider)\b/i,
  ],
  [
    "SEO crawler",
    /\b(?:AhrefsBot|SemrushBot|MJ12bot|DotBot|Bytespider|CCBot)\b/i,
  ],
  [
    "Link preview",
    /\b(?:Twitterbot|LinkedInBot|Slackbot|Discordbot|TelegramBot)\b/i,
  ],
  ["Automated browser", /\bHeadlessChrome\b/i],
];

export function getKnownBotName(userAgent) {
  if (typeof userAgent !== "string") return null;
  return knownBots.find(([, pattern]) => pattern.test(userAgent))?.[0] || null;
}

export function countUniqueKnownIps(visitors) {
  return new Set(
    visitors
      .map((visitor) => visitor.ipAddress?.trim())
      .filter((ip) => ip && !["unknown", "n/a"].includes(ip.toLowerCase())),
  ).size;
}
